import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Box, CampoEstatico, TipoCampoEstatico, Alerta, TipoAlerta } from "@intechprev/componentes-web";
import { HomeCard } from "./../HomeCard";
import { CalendarioPagamentoService, FichaFinanceiraAssistidoService } from "./../../../services";
import { PlanoVinculadoEntidade, ProcessoBeneficioEntidade } from "../../../entidades";
import { HomeContext } from "../../../contexts";
import { LoadingComponent } from "../../../components";

export const Assistido: React.FC = () => {
  const context = useContext(HomeContext);

  const [Plano, setPlano] = useState<PlanoVinculadoEntidade>(new PlanoVinculadoEntidade());
  const [Processo, setProcesso] = useState<ProcessoBeneficioEntidade>(new ProcessoBeneficioEntidade());
  const [UltimaFolha, setUltimaFolha] = useState<any>({});
  const [Calendario, setCalendario] = useState<Array<any>>([]);

  const [Loading, setLoading] = useState<boolean>(false);
  const [Erro, setErro] = useState<string>("");

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const Plano = await context.buscarPlano();

        const processoBeneficio = await context.buscarProcessoBeneficio();
        if (processoBeneficio && processoBeneficio.NUM_PROCESSO) {
          const ultimaFolha = await FichaFinanceiraAssistidoService.BuscarUltimaPorPlanoProcesso(Plano.CD_PLANO, processoBeneficio.CD_ESPECIE, processoBeneficio.ANO_PROCESSO, processoBeneficio.NUM_PROCESSO.toString());
          const calendario = await CalendarioPagamentoService.BuscarPorPlano(Plano.CD_PLANO);

          setUltimaFolha(ultimaFolha);
          setProcesso(processoBeneficio);
          setCalendario(calendario);
        }
        setPlano(Plano);
      }
      catch (e) {
        const err: any = e;
        setErro(err.response ? err.response.data : err);
      }
      finally {
        setLoading(false);
      }
    })();
  }, [context]);

  return (
    <div>
      {Loading && <LoadingComponent />}

      {!Loading && Erro !== "" && <Alerta tipo={TipoAlerta.danger} mensagem={Erro} />}

      {!Loading && Erro === "" && Processo &&
        <div>
          <Row>
            <Col>
              <HomeCard titulo={Plano.DS_PLANO}>
                {Plano.DS_CATEGORIA}
              </HomeCard>
            </Col>
            <Col>
              <HomeCard titulo={"Situação"}>
                {Processo.DS_ESPECIE}
              </HomeCard>
            </Col>
            <Col>
              <HomeCard titulo={"Data de Início do Benefício"}>
                {Processo.DT_INICIO_FUND}
              </HomeCard>
            </Col>
          </Row>

          {Processo.SALDO_ATUAL > 0 &&
            <Row>
              <Col>
                <HomeCard titulo={"Saldo de Conta Aplicável Atual - SCAA (em cotas)"}>
                  <CampoEstatico valor={Processo.SALDO_ATUAL} />
                </HomeCard>
              </Col>
              <Col>
                <HomeCard titulo={"Renda - % SCAA"}>
                  {Processo.VL_PARCELA_MENSAL}%
                </HomeCard>
              </Col>
              <Col>
                <HomeCard titulo={"Provável Encerramento do Benefício"}>
                  {Processo.DT_APOSENTADORIA}
                </HomeCard>
              </Col>
              {Plano.CD_PLANO !== "0001" &&
                <Col>
                  <HomeCard titulo={"Regime de Tributação"}>
                    {Plano.TIPO_IRRF === "2" ? "Regressivo" : "Progressivo"}
                  </HomeCard>
                </Col>
              }
            </Row>
          }

          <Row className={"mt-4"}>
            <Col tamanho={"8"}>
              {UltimaFolha.Proventos && UltimaFolha.Proventos.length > 0 &&
                <Box titulo={`Contracheque de ${UltimaFolha.Resumo.Referencia.substring(3)}`}
                  label={Plano.CD_PLANO === "0002" && `Valor da cota: ${UltimaFolha.Resumo.Indice.VALOR_IND}`}>
                  <h6 className={"text-right text-secondary mb-4"}></h6>
                  <h2 className={"text-center mb-5"}>Valor Líquido: <CampoEstatico valor={UltimaFolha.Resumo.Liquido} tipo={TipoCampoEstatico.dinheiro} /></h2>

                  <table className={"table table-striped table-sm"}>
                    <thead>
                      <tr>
                        <th>Rubrica</th>
                        <th>Tipo</th>
                        <th>Competência</th>
                        <th className={"text-right"}>Valor</th>
                      </tr>
                    </thead>
                    <tbody>
                      {UltimaFolha.Proventos.map((rubrica: any, index: number) => {
                        return (
                          <tr key={index}>
                            <td>{rubrica.DS_RUBRICA}</td>
                            <td className={"text-success"}>Provento</td>
                            <td>{rubrica.DT_COMPETENCIA}</td>
                            <td className={"text-right"}>
                              <CampoEstatico valor={rubrica.VALOR_MC} tipo={TipoCampoEstatico.dinheiro} />
                            </td>
                          </tr>
                        )
                      })}

                      {UltimaFolha.Descontos.map((rubrica: any, index: number) => {
                        return (
                          <tr key={index}>
                            <td>{rubrica.DS_RUBRICA}</td>
                            <td className={"text-danger"}>Desconto</td>
                            <td>{rubrica.DT_COMPETENCIA}</td>
                            <td className={"text-right"}>
                              <CampoEstatico valor={rubrica.VALOR_MC} tipo={TipoCampoEstatico.dinheiro} />
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>

                </Box>
              }
            </Col>

            <Col>
              <Box titulo={"Calendário de Pagamento"}>
                <table className={"table table-striped table-sm"}>
                  <tbody>
                    {Calendario.map((data: any, index: number) => {
                      return (
                        <tr key={index}>
                          <td>{data.DES_MES}</td>
                          <td className={"text-right"}>{data.NUM_DIA}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </Box>
            </Col>
          </Row>
        </div>
      }

      {!Processo &&
        <Alerta tipo={TipoAlerta.danger} mensagem={"Nenhum processo de benefício disponível para este plano."} />
      }
    </div>
  );
}